module.exports = __webpack_public_path__ + "img/tools.6bd1374.webp";